import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import CButton from '@/components/shared/CButton';
import { resolveThumbnailUrl } from '../../../core/presets';
import crosswordIcon from '@/angular-app/images/template/crossword.svg';
import type { CrosswordStyle } from '../../../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'CrosswordStyleListItem',
  props: {
    item: null,
    disabled: { type: Boolean },
    selected: { type: Boolean }
  },
  emits: ["edit", "remove"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'edit', value: CrosswordStyle): void;
    (event: 'remove', value: CrosswordStyle): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    item: CrosswordStyle;
    disabled?: boolean;
    selected?: boolean;
};





const thumbnailFailed = ref(false);
const icon = computed(() => (thumbnailFailed.value ? crosswordIcon : resolveThumbnailUrl(props.item) || crosswordIcon));

watch(
    () => props.item.thumbnail,
    () => {
        thumbnailFailed.value = false;
    }
);

return { __sfc: true,props, emit, thumbnailFailed, icon, CButton }
}

})